<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    for?: string;
    children?: Snippet;
  }

  let { for: htmlFor, children }: Props = $props();
</script>

<label
  for={htmlFor}
  class="block text-xs font-medium text-slate-400 uppercase tracking-wider mb-2"
>
  {@render children?.()}
</label>
